import { bindReset, parseRecoveryTokens } from '../ui/auth';
import { navigateTo } from '../router';

let cleanupReset: (() => void) | null = null;

// Страница перехода по ссылке сброса пароля (redirect из письма).
export function mountResetPassword(): void {
  const screen = document.getElementById('screen-auth');
  if (screen) screen.classList.remove('hidden');

  const cardLogin = document.getElementById('card-login');
  const cardSignup = document.getElementById('card-signup');
  const cardForgot = document.getElementById('card-forgot');
  const cardReset = document.getElementById('card-reset');
  const formReset = document.getElementById('form-reset') as HTMLFormElement | null;
  const resetError = document.getElementById('reset-error');
  const linkToLogin = document.getElementById('link-reset-to-login');

  cardLogin?.classList.add('hidden');
  cardSignup?.classList.add('hidden');
  cardForgot?.classList.add('hidden');
  if (!cardReset || !formReset) return;

  // Ссылка «Войти» уводит на форму входа (и убирает recovery-hash).
  const onToLogin = (e: Event) => {
    e.preventDefault();
    navigateTo('/auth', true);
  };
  linkToLogin?.addEventListener('click', onToLogin);

  const accessToken = parseRecoveryTokens();

  if (!accessToken) {
    // Нет валидного токена — показываем ошибку вместо формы.
    resetError?.classList.remove('hidden');
    formReset.classList.add('hidden');
    cardReset.classList.remove('hidden');
    cleanupReset = () => linkToLogin?.removeEventListener('click', onToLogin);
    return;
  }

  resetError?.classList.add('hidden');
  formReset.classList.remove('hidden');
  cardReset.classList.remove('hidden');

  const unbind = bindReset(formReset, accessToken, () => {
    // После смены пароля чистим hash и уводим на форму входа.
    navigateTo('/auth', true);
  });
  cleanupReset = () => {
    unbind();
    linkToLogin?.removeEventListener('click', onToLogin);
  };
}

export function unmountResetPassword(): void {
  cleanupReset?.();
  cleanupReset = null;
}
